import { Scope } from '@headless-workspace/config';
import { z } from 'zod';

export const SanityCheckScopeDTO = z.union([z.literal(Scope.HomePage), z.literal(Scope.ProductDetailPage)]);
